import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import Icon from '@helsenorge/designsystem-react/components/Icon';
import ChevronLeft from '@helsenorge/designsystem-react/components/Icons/ChevronLeft';
import styles from './styles.module.scss';
export const LinkContent = (props) => (_jsxs(_Fragment, { children: [_jsx(Icon, { svgIcon: ChevronLeft, isHovered: props.isHovered }), _jsx("span", { className: styles.breadcrumb__label, children: props.children })] }));
